import { formatShortDate } from '../lib/format'
import Tabs from './Tabs'

// The head of a space, on the ice band: breadcrumb back to the list, the
// engagement's name with its purpose under it, the Send to Fancy Notes button
// on the right, then the principal's access card and the People | Results |
// Settings tabs. Shared by both tabs so switching never moves the title. `action` and
// `accessCard` are the page's — both change the space.
export default function SpaceHeader({
  space,
  tab,
  onTab,
  onSpaces,
  peopleCount = null,
  resultsCount = null,
  action = null,
  accessCard = null,
}) {
  const count = (value) => value !== null && <span className="tabs__count">{value}</span>
  return (
    <section className="disc-band disc-band--alt space-hero">
      <div className="hero">
        <div className="hero__text">
          <p className="overline space-crumb hero__eyebrow">
            <button type="button" className="space-crumb__link" onClick={onSpaces}>
              Spaces
            </button>
            <span aria-hidden="true">›</span>
            <span>{space.client_name}</span>
          </p>
          <h1 className="text-h1">{space.engagement}</h1>
          {/* The purpose is the subtitle; a space without one shows its
              template and end date, so the line is never blank. */}
          <p className="text-body-lg hero__lede">
            {space.purpose ||
              [space.template_name, `Ends ${formatShortDate(space.ends_at)}`]
                .filter(Boolean)
                .join(' · ')}
          </p>
        </div>
        {action}
      </div>
      {accessCard}
      <Tabs
        id="space"
        label="Space view"
        className="tabs--band"
        selected={tab}
        onSelect={onTab}
        tabs={[
          { id: 'people', label: <>People{count(peopleCount)}</> },
          { id: 'results', label: <>Results{count(resultsCount)}</> },
          { id: 'settings', label: 'Settings' },
        ]}
      />
    </section>
  )
}
